import './wdyr'
import { createRoot } from 'react-dom/client'
import { setAppElement } from 'react-modal'
import { App } from './App'

import 'bootstrap/dist/css/bootstrap.css'
import '@centivo/react-components/dist/index.css'
import './assets/css/style.scss'

setAppElement('#root')

const container = document.getElementById('root') as HTMLElement
const root = createRoot(container)

root.render(<App />)
